
import {
    useState
} from 'react';
import ElementFrame from '../utils-components/ElementFrame';

import '../component.css';
import process_vars from './process_vars';
import PropSection from '../utils-components/PropSection';

export default function Signature({ id, comps, setter, vw, gridSize, sel, setSel, hov, setHov, vars, setVars, contextMenu, setContextMenu, magneticGrid, setMagneticGrid, magneticGridPartitions }) {

    let background_color = '';
    if (hov === id) {
        background_color = '#e8f1ff';
    } else {
        background_color = process_vars(comps[id].props.backgroundColor, vars);
    } if (sel === id) {
        background_color = process_vars(comps[id].props.backgroundColor, vars);
    }

    let innerContent = <p style={{
        width: '90%',
        textAlign: 'center',
        fontWeight: '300',
        color: process_vars(comps[id].props.color, vars)
    }}>
        Signature Region
    </p>;

    return (
        <div>
            <ElementFrame id={id} comps={comps} setter={setter} vw={vw}
                gridSize={gridSize} vars={vars} setSel={setSel} setHov={setHov}
                setContextMenu={setContextMenu} magneticGrid={magneticGrid}
                magneticGridPartitions={magneticGridPartitions} preset="large"
                style={{
                    backgroundColor: background_color,
                    textAlign: 'center',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: 'hidden',
                    zIndex: '0',
                    border: process_vars(comps[id].props.borderEnabled, vars) ?
                        `${process_vars(comps[id].props.borderColor, vars)} solid ${process_vars(comps[id].props.borderWidth)}pt` : '#000 solid 0px',
                    transition: 'transform 0.05s ease'
                }}>{innerContent}</ElementFrame>
        </div>
    );

}

export function SignatureProperties({ id, comps, setter, setSel, externals, setExternals, creationIndex, setCreationIndex }) {

    return (<>
        <PropSection title="Layout">
            <p className='panel-label'>Position: </p>
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].position[0] = e.target.value;
                setter(new_comps);
            }} value={comps[id].position[0]} style={{ width: '15%' }} placeholder='X' />
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].position[1] = e.target.value;
                setter(new_comps);
            }} value={comps[id].position[1]} style={{
                width: '15%',
                marginLeft: '0.5vmax'
            }} placeholder='Y' />
            <br /> <br />
            <p className='panel-label'>Dimensions: </p>
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].size[0] = e.target.value;
                setter(new_comps);
            }} value={comps[id].size[0]} style={{ width: '15%' }} placeholder='Width' />
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].size[1] = e.target.value;
                setter(new_comps);
            }} value={comps[id].size[1]} style={{
                width: '15%',
                marginLeft: '0.5vmax'
            }} placeholder='Height' />
        </PropSection>

        <PropSection title="Appearance">
            <p className='panel-label'>Background Color: </p>
            <input className='panel-input' style={{
                width: '17.5%',
                marginRight: '0.75vmax'
            }} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.backgroundColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.backgroundColor} />
            <p className='panel-label'>or</p>
            <input type='color' className='panel-color-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.backgroundColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.backgroundColor} />
            <br /> <br />
            <p className='panel-label'>Pen Color: </p>
            <input className='panel-input' style={{
                width: '17.5%',
                marginRight: '0.75vmax'
            }} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.color = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.color} />
            <p className='panel-label'>or</p>
            <input type='color' className='panel-color-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.color = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.color} />
        </PropSection>

        <PropSection title="Border">
            <p className='panel-label'>Border Enabled: </p>
            <input type="checkbox" checked={comps[id].props.borderEnabled} onClick={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderEnabled = !new_comps[id].props.borderEnabled;
                setter(new_comps);
            }}></input>
            <br /><br />
            <p className='panel-label'>Border Color: </p>
            <input className='panel-input' style={{
                width: '17.5%',
                marginRight: '0.75vmax'
            }} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.borderColor} />
            <p className='panel-label'>or</p>
            <input type='color' className='panel-color-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.borderColor} />
            <br /><br />
            <p className='panel-label'>Border Width:</p>
            <input type='range' min='1' max='10' value={comps[id].props.borderWidth} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderWidth = parseInt(e.target.value);
                setter(new_comps);
            }}></input>
        </PropSection>

        <div className="prop-footer">
            <a className='panel-button' onClick={(e) => {
                e.preventDefault();
                setSel(-1);
            }}>Ok</a>
            <a className='panel-button prop-danger' onClick={(e) => {
                e.preventDefault();
                let new_comps = [...comps];
                new_comps.splice(id, 1);
                setSel(-1);
                setter(new_comps);
            }}>Delete</a>
        </div>
    </>);

}

export function SignatureAdder({ comps, setComps, setView, page, pageId, setSelectedEl, creationIndex, setCreationIndex }) {

    const [hovered, setHovered] = useState(false);

    return (
        <div className="toolbar-element" style={{
            // border: '1px #FAF3DD solid',
            // display: 'inline-block',
            // padding: '1vmax',
            // color: '#1f2933',
            // backgroundColor: hovered ? '#FAF3DD' : 'black',
            // transition: 'background-color 0.1s, color 0.1s'
        }} onMouseEnter={() => {
            setHovered(true);
        }} onMouseLeave={() => {
            setHovered(false);
        }} onClick={(e) => {
            e.preventDefault();
            let new_comps = [...comps];
            new_comps.push({
                page: page,
                page_id: pageId,
                type: 'intermediate/Signature',
                name: 'Signature',
                ...(creationIndex != -1 && {creation_index: creationIndex}),
                position: [0.475, 0.15 + document.getElementById("wrapper").scrollTop / document.getElementById("wrapper").offsetWidth],
                size: [0.10, 0.05],
                props: {
                    backgroundColor: '#ffffff',
                    color: '#000',
                    data: '',
                    borderEnabled: true,
                    borderColor: '#000000',
                    borderWidth: 1
                },
                script: [
                    {
                        type: "event/start",
                        children: []
                    },
                    {
                        type: "event/change",
                        children: []
                    },
                    {
                        type: "event/save",
                        children: []
                    }
                ],
                error: "",
                warning: "",
                disable: false
            });
            if (creationIndex != -1) {
                setCreationIndex(creationIndex + 1);
            }
            setComps(new_comps);
            setView('');
            setSelectedEl(comps.length);
        }}>
            <i className="fa fa-solid fa-pencil" style={{
                color: '#e11d48'
            }}></i>
            <p className='panel-label' style={{
                color: '#1f2933',
                marginLeft: '1vmax',
                fontSize: '1.15vmax'
            }}>Signature</p>
        </div>
    );

}